import React from 'react';
import { NavLink, Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { coffee } from '@fortawesome/free-brands-svg-icons'
export default function  Footer () {
            
return (
    <div className="footer">
      <div className="footer__container">

          <div className="footer__container__content">
                {/* <h5 className="footer__header">Code<span>Shop225</span></h5> */}
                 <div className='logo__box'>
                               <NavLink to="/"><img src="/IMG_9959.PNG" alt="" /></NavLink>
                            </div>
                <p className="footer__header__p">Suivez-nous :</p>
                <div className="social__media__box">
                  <Link to='https://www.facebook.com/share/1CY92ZdjbZ/?mibextid=wwXIfr'><p className="footer__header__p"><i className="fa-brands fa-facebook"></i></p></Link>
                   <Link to=''><p className="footer__header__p"><i className="fa-brands fa-instagram"></i></p></Link>
                  {/* <Link to='https://www.tiktok.com/@codeshop225?_t=ZM-8yzKlDJQ7Ub&_r=1'> <p className="footer__header__p"><i className="fa-brands fa-tiktok"></i></p></Link> */}
                 <Link> <p className="footer__header__p"><i className="fa-brands fa-tiktok"></i></p></Link>
      
                </div>
          </div>

          <div className="footer__container__content">
                <h5 className="footer__header">A propos</h5>
               <Link to='/A__propos'><p className="footer__header__p">Nous</p></Link>
              <Link to='/Contactez-nous'><p className="footer__header__p">Contactez-nous</p></Link>
               <Link to='/comment__installer/'><p className="footer__header__p">Comment-installer ?</p></Link>
              {/* <Link to='/Contactez-nous'><p className="footer__header__p">Contactez-nous</p></Link> */}
          </div>

          <div className="footer__container__content">
                <h5 className="footer__header">Contacts</h5>
                  <p className="footer__header__p"><i className="fa-solid fa-location-dot"></i> Cocody Palmeraie</p>
                  <p className="footer__header__p"><i className="fa-solid fa-envelope"></i> infos@codeshop225.ci</p>
                  <a className="footer__contact"href="https://wa.me/2250101885981" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i> +225 01 01 88 59 81</a>
                  <p className="footer__header__p"><i className="fa-solid fa-globe"></i> www.codeshop225.ci</p>
          </div>
          <div className="footer__container__content">
              <h5 className="footer__header">Methode de Paiement</h5>
              <p className="footer__header__p">Paiement sécurisé</p>
              <div className="payment__content">
                  <div className="payment__img">
                      <img src="https://yop.l-frii.com/wp-content/uploads/2025/02/WAVE-recrute-pour-ce-poste-23-fevrier-2025.png" alt="" />
                  </div>
              </div>
          </div>
      </div>
          <div className='copyright'>
            <p>&copy; {new Date().getFullYear()} CodeShop225 - Tous droits réservés.</p>
                        <p><span> Designed by Doumbia Fode (+225 07 77 88 00 82)</span></p>
            
      </div>
    </div>

    );
}

